import { REGISTER_FROM_NUMBER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function registerFromNumber() {
  return callingAPIMethodWithQueue(REGISTER_FROM_NUMBER);
}